<template>
      <v-col>
          <v-card flat>
         <v-data-table
            :key="componentKey"
            :headers="computedHeaders"
            :items="tableItems"
            class="elevation-1"
            :loading="dashboardPresencesLoadStatus===1"
            :options.sync="tableOptions"
            :server-items-length="options.lineCount"
            hide-default-footer
            must-sort
          >
            <template v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title>Dzieci nieobecne</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-progress-circular v-if="autoRefresh" class="mr-2" color="primary" width="3" size="24" :value="100-Math.round(refreshCount/60*100)"></v-progress-circular>
                <v-checkbox v-model="autoRefresh" class="mt-5" label="Automatyczne odświeżanie"></v-checkbox>
                <v-divider
                  class="mx-4"
                  inset
                  vertical
                ></v-divider>
                <v-btn  :to="{name: 'pulpit' }" outlined class="mb-2 mt-2"  color="primary" active-class="aa" exact>
                    <v-icon>mdi-close-thick</v-icon>
                </v-btn>
              </v-toolbar>
            </template>

          </v-data-table> 
          <div class="text-center pt-2">
            <v-btn @click="loadMore" v-if="!options.itemAdded && options.lineCount-tableItems.length>0 && dashboardPresencesLoadStatus===2" small color="primary"><v-icon left>mdi-download</v-icon>Załaduj więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadDashboardPresences" v-else-if="options.itemAdded && options.lineCount-tableItems.length>0" small color="primary"><v-icon left>mdi-reload</v-icon>Odśwież tabele aby móc załadować więcej ({{ options.lineCount-tableItems.length }})</v-btn>
            <v-btn @click="loadDashboardPresences" v-else-if="options.itemSearched" small color="primary"><v-icon left>mdi-reload</v-icon>Anuluj wyszukiwanie</v-btn>
          
          </div>
          </v-card>
      
      </v-col>
</template>
<script>
 
  export default {
   data: () => ({
      componentKey:0,
      tableOptions: {},
      autoRefresh:false,
      refreshCount:0,
      interval:{},
      headers: [
        { text: '',align: 'start',sortable: false,value: 'lp',filterable:false},
        { text: 'Grupa - Sala', value: 'course',filterable:true,filterColumn:"courses.name" },
        { text: 'Nazwisko', value: 'surname',filterable:true,filterColumn:"children.surname" },
        { text: 'Imię', value: 'name',filterable:true,filterColumn:"children.name" },
        { text: 'Uwagi', value: 'note',filterable:false,filterColumn:"presences.note" },
      ],
    }),
    validations: {

    },
    watch: {
      tableOptions: {
        handler () {
          var currentOptions = {...this.options};
          const { sortBy, sortDesc } = this.tableOptions
        
          //zmiana sortowania
          if (sortBy.length === 1 && sortDesc.length === 1) {
            currentOptions.orderBy = _.find(this.headers,{'value':sortBy[0]}).filterColumn;
            currentOptions.orderDirection = sortDesc[0]?'desc':'asc';
            this.options = currentOptions;
          } 
        },
        deep: true,
      },
      autoRefresh(val){
        if(val){
          this.refreshCount = 0;
          this.interval = setInterval(() => {
            this.refreshCount++;
            if(this.refreshCount>=60){
              this.loadDashboardPresences();
              this.refreshCount = 0;
            }
          }, 1000);
        }else{
          clearInterval(this.interval);
        }
      }
    },
    beforeRouteLeave (to, from, next) {
      clearInterval(this.interval);
      next();
    },
    computed: {
      user(){
        return this.$store.getters.getUser;
      },
      lookups(){
        return this.$store.getters.getLookups;
      },
      options:{
        get () {  
          return this.$store.getters.getDashboardPresenceOptions;
        },
        set (value) {
          this.search='';
          this.$store.dispatch( 'setDashboardAbsentOptions', {options:value} )
          }
      },
      tableItems(){
        return this.$store.getters.getDashboardPresences;
      },
      dashboardPresencesLoadStatus(){
        return this.$store.getters.getDashboardPresencesLoadStatus;
      },
      
      computedHeaders () {
        // if(!this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='status' && h.value!=='actions')
        // else if(this.showDeleted && this.user.permissions['dictionary'] <= 5) return this.headers.filter(h => h.value!=='actions')
        // else if(!this.showDeleted) return this.headers.filter(h => h.value!=='status')
        // else 
        return this.headers
      },
     
    },
    mounted(){
      if(this.lookups.years.length>0){
        this.loadDashboardPresences();
      }else{
        this.$store.dispatch( 'loadLookups' );
        setTimeout(() => {
          this.loadDashboardPresences();
        }, 2000)
      }
    },
    methods: {
      loadDashboardPresences(){
        this.$store.dispatch( 'loadDashboardAbsent' );
      },
      loadMore(){
        this.$store.dispatch( 'loadMoreDashboardAbsent' );
      },
      sumField(key) {
        return this.tableItems.reduce((a, b) => a + ((b && b[key])?1:0 || 0), 0)
      },
    },
  }
</script>

<style scoped>

</style>